import { isErrorWithMessage, isFetchBaseQueryError } from "./typeUtils";
export default function handleMutationError(error, fallbackMessage) {
    if (fallbackMessage === void 0) { fallbackMessage = "An error occurred"; }
    if (isFetchBaseQueryError(error)) {
        var errMessage = "error" in error ? error.error : JSON.stringify(error.data);
        throw new Error("Status ".concat(error.status, ": ").concat(errMessage));
    }
    else if (isErrorWithMessage(error)) {
        throw new Error(error.message);
    }
    else {
        throw new Error(fallbackMessage);
    }
}
